import Link from "next/link";
import Image from "next/image";
import { I } from "@/components/kamibot-v2/discord";
import { Container } from "@/components/kamibot-v2/common";

export function Foot() {
  return (
    <footer className="foot">
      <Container>
        <div className="foot-grid">
          <div className="foot-brand">
            <div className="brand">
              <span className="brand-mark">
                <Image
                  src="/kamibot-character/kamibot-portrait.png"
                  alt=""
                  width={36}
                  height={36}
                />
              </span>
              <span className="brand-name">카미봇</span>
            </div>
            <p>
              복잡한 게 싫어서 디스코드 서버를 편하게 쓰려고 만든 봇이에요. 한 사람이 시작했고, 지금도 그 마음 그대로 운영해요.
            </p>
            <div className="foot-mascot-line">
              <div className="av">
                <Image
                  src="/kamibot-character/kamibot-portrait.png"
                  alt=""
                  width={36}
                  height={36}
                />
              </div>
              <div className="bub gowun">오늘도 좋은 하루 보내세요!</div>
            </div>
          </div>
          <div className="foot-col">
            <h5>제품</h5>
            <ul>
              <li>
                <a href="#features">기능</a>
              </li>
              <li>
                <a href="#start">시작하기</a>
              </li>
              <li>
                {/* TODO: 대시보드 외부 링크 확정 */}
                <Link href="/dashboard">대시보드</Link>
              </li>
              <li>
                {/* TODO: 업데이트 노트 라우트 */}
                <a href="#">업데이트 노트</a>
              </li>
            </ul>
          </div>
          <div className="foot-col">
            <h5>커뮤니티</h5>
            <ul>
              <li>
                {/* TODO: 지원 서버 링크 */}
                <a href="#">지원 서버</a>
              </li>
              <li>
                {/* TODO: 피드백 링크 */}
                <a href="#">피드백</a>
              </li>
              <li>
                <a href="https://stats.kamibot.app/" target="_blank" rel="noopener noreferrer">업타임 상태</a>
              </li>
              <li>
                {/* TODO: 로드맵 링크 */}
                <a href="#">로드맵</a>
              </li>
            </ul>
          </div>
          <div className="foot-col">
            <h5>법적 고지</h5>
            <ul>
              <li>
                <Link href="/terms">이용약관</Link>
              </li>
              <li>
                <Link href="/privacy">개인정보 처리방침</Link>
              </li>
              <li>
                <Link href="/terms#s1">사업자 정보</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="foot-bottom">
          <span>
            © 2026 카미봇 · Kamibot is operated by Kamilake OÜ (Estonia · reg. 17543398) ·{" "}
            <a href="mailto:contact@kamilake.com">contact@kamilake.com</a>
          </span>
          <span style={{ display: "inline-flex", gap: 14 }}>
            {/* TODO: 소셜 링크 확정 */}
            <a href="#" aria-label="Discord">
              <I.discord />
            </a>
            <a href="#" aria-label="Twitter">
              <I.twitter />
            </a>
            <a href="#" aria-label="GitHub">
              <I.github />
            </a>
          </span>
        </div>
      </Container>
    </footer>
  );
}
